import { Divider as MUIDivider, DividerProps as MUIDividerProps } from '@mui/material'

export function Divider(props: MUIDividerProps) {
  return <MUIDivider {...props} />
}
